// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__ul84T","item":"SegmentedControl_item__CZFCx","active":"SegmentedControl_active__1WZLy"};